import React from 'react';
import { IconWrapper } from './elements';
import { Icon } from '../../components/Icon'; // keep long to avoid circular imports

export const sizeToIconSize = {
  small: 'medium',
  medium: 'large',
  large: 'xlarge'
};
export const addIconToChildren = ({
  children,
  size,
  iconSrc,
  iconSide
}) => {
  const icon = iconSrc && /*#__PURE__*/React.createElement(IconWrapper, {
    iconSide: iconSide,
    size: size,
    hasChildren: !!children
  }, /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    size: sizeToIconSize[size],
    fill: "currentColor"
  }));
  return addToSide({
    children,
    element: icon,
    side: iconSide
  });
};
export const addToSide = ({
  children,
  element,
  side
}) => /*#__PURE__*/React.createElement(React.Fragment, null, side === 'left' && element, children, side === 'right' && element);